module.exports = __webpack_public_path__ + "img/help_img.4c3efa62.png";